import React from "react";

function PrinterButton({ ticket }) {
    const handlePrint = () => {
        // Open the print dialog with the current window's content
        const printWindow = window.open('', '', 'height=600,width=800');
        
        printWindow.document.write('<html><head><title>Ticket Print</title></head><body>');
        printWindow.document.write(`
            <h1>Ticket Details</h1>
            <p><strong>Placa:</strong> ${ticket.Placa || "Sin Placa"}</p>
            <p><strong>Entrada:</strong> ${new Date(ticket.TiempoEntrada).toLocaleString()}</p>
            <p><strong>Salida:</strong> ${ticket.TiempoSalida 
                ? new Date(ticket.TiempoSalida).toLocaleString() 
                : "No registrado"}</p>
            <p><strong>Estado:</strong> ${ticket.Estado}</p>
        `);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print(); // This triggers the print dialog
    };

    return (
        <button className="btn btn-primary" onClick={handlePrint}>
            Print Ticket
        </button>
    );
}

export default PrinterButton;
